import api from '../../api/services';
import {config} from '../../../services/configService';

export const SERVICES_NAMESPACE = 'services';
export const EXTRA_SERVICES_GETTER = 'extraServices';
export const SELECT_EXTRA_SERVICE_GETTER = 'selectExtraService';
export const SELECTED_EXTRA_SERVICES_GETTER = 'selectedExtraServices';
export const ADDITIONAL_SERVICE_TOTAL_PRICE_GETTER = 'additionalServiceTotalPrice';
export const UPDATE_SERVICES_ACTION = 'updateServices';

export default {
    namespaced: true,
    state: {
        /**
         * Extra services
         *
         * @var {Array}
         */
        extraServices: config.extraServices
    },
    getters: {
        /**
         * Get state of extra services
         *
         * @param {Object} state - Vuex state
         *
         * @return {Array}
         */
        extraServices(state) {
            return state.extraServices;
        },
        /**
         * Get state of checked extra services
         *
         * @param {Object} state - Vuex state
         *
         * @return {Array}
         */
        selectExtraService: state => extraServiceId => {
            return !!state.extraServices.find(extraService => extraService.active && extraService.id === extraServiceId);
        },
        /**
         * Get state of selected extra services
         *
         * @param {Object} state - Vuex state
         *
         * @return {Array}
         */
        selectedExtraServices(state) {
            return state.extraServices.filter(extraService => extraService.active);
        },
        /**
         * Get state of extra services total price
         *
         * @param {Object} state - Vuex state
         * @param {Object} getters - Vuex getters
         *
         * @return {int|float}
         */
        additionalServiceTotalPrice(state, getters) {
            return getters.selectedExtraServices.reduce((accumulator, service) => {
                return accumulator + parseFloat(service.money) * parseInt(service.quantity);
            }, 0);
        }
    },
    actions: {
        /**
         * Update services
         *
         * @param {Object} context - Vuex context
         *
         * @return {void}
         */
        updateServices(context) {
            const selectedExtraServices = context.getters.selectedExtraServices.map(extraService => ({
                id: extraService.id,
                slug: extraService.slug,
                quantity: extraService.quantity
            }));
            api.updateServices(selectedExtraServices);
        }
    }
};